module.exports = __webpack_public_path__ + "img/add-departure-climbing-table-icon.d77e0819.svg";